export default "__VITE_PUBLIC_ASSET__6e2013dc__"